import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Suggest from './views/Suggest.vue'
import SuggestList from './views/SuggestList.vue'
import About from './views/About.vue'
import News from './views/News.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/news',
      name: 'news',
      component: News
    },
    {
      path: '/suggest',
      name: 'suggest',
      component: Suggest
    },
    {
      path: '/suggestlist',
      name: 'suggestlist',
      component: SuggestList
    },
    {
      path: '/progress',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: About
    }
  ]
})
